import React from "react";
import "./Home.css";

function loadScript(src) {
    return new Promise((resolve) => {
        const script = document.createElement('script')
        script.src = src
        script.onload = () => {
            resolve(true)
        }
        script.onerror = () => {
            resolve(false)
        }
        document.body.appendChild(script)
    })
}


function Home() {

    async function showrazorpay() {
        const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js')

        if (!res) {
			return alert('Razorpay SDK failed to load. Are you online?')
			
		}

        const data = await fetch(`https://razorpaybackend-s8la.onrender.com/razorpay`,{method:"POST"}).then(res =>{
            return res.json();
        }).catch(err=>console.log("Errorrr"));
        // console.log(data);

        const options = {
            "key": data.key_id,
            "amount":  data.amount,
            "currency": data.currency,
            order_id: data.id,
            name: "Donation",
            description: "Thanks for giving your valuable Time and Support.",
            image: "https://images.unsplash.com/photo-1603827457577-609e6f42a45e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=889&q=80",
            // prefill: {
            //     "name": ""
            // }
        };
        const rzpy = new window.Razorpay(options);
        rzpy.open();
    }


    return (
        <>
            <div className="home_container">
                <div className="quote">
                    <p>We make a living, <br />
                    <span>By what we Get.<br /></span></p>
                     <p>We make a life,<br />
                     <span>By what we Give. </span></p>
                </div>

                <div className="home_image">
                    <img src="./images/donate.jpg" alt="Loading..." className="homeimg" />
                </div>


            </div>

            <div className="btn">
                <button onClick={showrazorpay}>Donate</button>
            </div>
        </>
    )
}

export default Home;